var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHappy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 45,
    viewBox: "0 0 45 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.5 45C34.9264 45 45 34.9264 45 22.5C45 10.0736 34.9264 0 22.5 0C10.0736 0 0 10.0736 0 22.5C0 34.9264 10.0736 45 22.5 45Z",
    fill: "#FFD93B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.0002 22.5C45.0002 34.9312 34.9244 45 22.5002 45C15.4268 45 9.11269 41.7375 4.98535 36.6258C8.84551 39.7477 13.7603 41.6109 19.1111 41.6109C31.5353 41.6109 41.6111 31.5422 41.6111 19.1109C41.6111 13.7602 39.7478 8.84531 36.626 4.98515C41.7306 9.1125 45.0002 15.4266 45.0002 22.5Z",
    fill: "#F4C534"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.7772 23.3592C32.7274 23.3592 34.3083 21.7783 34.3083 19.8281C34.3083 17.878 32.7274 16.297 30.7772 16.297C28.827 16.297 27.2461 17.878 27.2461 19.8281C27.2461 21.7783 28.827 23.3592 30.7772 23.3592Z",
    fill: "#3E4347"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.0596 17.6312C31.5201 17.3919 30.9571 17.4811 30.8022 17.8304C30.6473 18.1797 30.9591 18.6568 31.4986 18.8961C32.0382 19.1354 32.6012 19.0462 32.7561 18.6969C32.911 18.3476 32.5992 17.8705 32.0596 17.6312Z",
    fill: "#5A5F63"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.2225 23.3592C16.1727 23.3592 17.7536 21.7783 17.7536 19.8281C17.7536 17.878 16.1727 16.297 14.2225 16.297C12.2723 16.297 10.6914 17.878 10.6914 19.8281C10.6914 21.7783 12.2723 23.3592 14.2225 23.3592Z",
    fill: "#3E4347"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.504 17.6307C14.9644 17.3914 14.4014 17.4805 14.2465 17.8298C14.0916 18.1791 14.4034 18.6563 14.943 18.8955C15.4825 19.1348 16.0455 19.0457 16.2004 18.6964C16.3553 18.3471 16.0435 17.8699 15.504 17.6307Z",
    fill: "#5A5F63"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.2832 31.382C12.8585 30.9826 12.8388 30.3146 13.2382 29.8913C13.6375 29.4681 14.3041 29.447 14.7288 29.8463C19.0868 33.9484 25.9127 33.9484 30.2707 29.8463C30.6954 29.447 31.3619 29.4681 31.7613 29.8913C32.1607 30.316 32.141 30.9826 31.7163 31.382C26.5483 36.2476 18.4511 36.2476 13.2832 31.382Z",
    fill: "#3E4347"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 45,
    height: 45,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHappy);
export default __webpack_public_path__ + "static/media/happy.a740ecb6855df2e17db5f5c8c6f36560.svg";
export { ForwardRef as ReactComponent };